var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"6"}},[_c('crm-company-tag-manager',{attrs:{"view_type":"master_tag_manager"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }